import { useTranslation } from "react-i18next";
import { createFormContext } from "@mantine/form";
import { CreateCampaignInquiryInput } from "src/graphql/generated/graphql";
import { DeepPartial } from "src/types/utils";

import { getFormValues } from "./utils";

export type CreateCampaignInquiryFormValues = DeepPartial<Omit<CreateCampaignInquiryInput, "tags" | "outcome">>;

export const [CreateCampaignInquiryFormProvider, useCreateCampaignInquiryFormContext, useForm] =
    createFormContext<CreateCampaignInquiryFormValues>();

export const useCreateCampaignInquiryForm: typeof useForm = (values) => {
    const { t } = useTranslation(["common"]);

    return useForm({
        ...values,
        initialValues: getFormValues(values?.initialValues),
        validateInputOnBlur: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        validate: (values) => ({
            tenantId: !values?.tenantId ? t("campaign_error_missingtenant") : null,
            displayTenantIds: !(values?.displayTenantIds?.length > 0)
                ? t("campaign_error_missingdisplaytenants")
                : null,
            name: !(values?.name?.length > 0) ? t("campaign_error_missingname") : null,
            ...(values?.products || []).reduce((errors, product, index) => {
                return {
                    ...errors,
                    [`products.${index}.ean`]:
                        product?.ean && !/^[0-9]{13}$/.test(product.ean) ? t("campaign_error_invalidean") : null,
                    [`products.${index}.category`]: !product?.category?.key
                        ? t("campaign_error_missingproductcategory")
                        : null,
                    [`products.${index}.name`]: !(product?.name?.length > 0)
                        ? t("campaign_error_missingproductname")
                        : null,
                };
            }, {}),
        }),
    });
};
